<template>
  <div class="contentContainer">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContentContainer'
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/mixins';

.contentContainer {
  @include bpOnlyPc() {
    margin-top: 60px;
  }
  @include bpOnlySp() {
    margin-top: 42px;
  }
}
</style>
